import React, { useState, useEffect } from "react";
import BootstrapTable from "react-bootstrap-table-next";
import moment from "moment";

const SymptomsList = ({...props}) => {

  const srNumberFormatter = (cell, row, rowIndex, formatExtraData) => {
    if (props.currentPage > 1)
      return <>{props.perPage * (props.currentPage - 1) + (rowIndex + 1)}</>;
    else return <>{rowIndex + 1}</>;
  };

  const nameFormatter = (cell, row) => {
    return (
      <>
        <div>
          {" "}
          {`${cell.firstName !== null ? cell.firstName : ""} ${cell.lastName !== null ? cell.lastName : ""
            }`}
        </div>
      </>
    );
  };

  const dateFormatter = (cell, row) => {
    return `${moment(row.eventTimestamp).format("MM/DD/YYYY")}  ${moment(
      row.eventTimestamp
    ).format("hh:mm A")}`;
  };

  const durationFormatter = (cell, row) => {
    return  row.duration !== null ? `${row.duration} ${row.durationType}` : "";
  };

  const columns = [
    {
      dataField: "id",
      text: "No.",
      formatter: srNumberFormatter,
      headerStyle: () => {
        return { width: "48px" };
      },
    },
    {
      dataField: "eventTimestamp",
      text: "REPORTED SYMPTOM DATE/TIME",
      formatter: dateFormatter,
    },
    {
      dataField: "symptom.name",
      text: "SYMPTOM NAME",
    },
    {
      dataField: "severity.severity",
      text: "SEVERITY",
    },
    {
      dataField: "duration",
      text: "DURATION",
      formatter: durationFormatter,
    },
    {
      dataField: "otherSymptom",
      text: "OTHER SYMPTOM",
    },
    {
      dataField: "symptomDescription",
      text: "SYMPTOM DESCRIPTION",
    },
  ];

  const defaultSorted = [
    {
      dataField: "startDate",
      order: "desc",
    },
  ];

  return (
      <div>
        <BootstrapTable
          keyField="id"
          data={props.symptomsList.sort((t1, t2) => {
            if (t1.eventTimestamp > t2.eventTimestamp) return -1;
            if (t1.eventTimestamp < t2.eventTimestamp) return 1;
            return 0;
          })}
          columns={columns}
          striped
          hover
          condensed
          bordered={false}
          //defaultSorted={defaultSorted}
        />
      </div>
  );
};

export default SymptomsList;
